(function () {
  var R = window.jzRoutes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  var responsiveImage = function (url, element, ceiling) {
    var parsed = new URL(url, window.location.origin);
    if (parsed.hostname.indexOf('shopify.com') === -1 && parsed.pathname.indexOf('/cdn/shop/') === -1) return { src: url, srcset: '' };
    var width = Math.min(ceiling, Math.max(160, Math.ceil((element.clientWidth || 200) * Math.min(window.devicePixelRatio || 1, 2))));
    var choices = [160, 240, 320, 480, 640, 720, 900].filter(function (size) { return size <= ceiling; });
    width = choices.find(function (size) { return size >= width; }) || ceiling;
    parsed.searchParams.set('width', width);
    var src = parsed.href;
    var srcset = choices.map(function (size) { parsed.searchParams.set('width', size); return parsed.href + ' ' + size + 'w'; }).join(', ');
    return { src: src, srcset: srcset };
  };

  /* Die Hero-Figuren wechseln direkt beim Aufruf und danach langsam weiter. */
  $$('[data-hero-stage]').forEach(function (stage) {
    var slots = $$('[data-hero-slot]', stage);
    var page = parseInt(stage.getAttribute('data-page'), 10) || 1;
    var pages = parseInt(stage.getAttribute('data-pages'), 10) || 1;
    var section = stage.getAttribute('data-section');
    var familyOf = function (title) {
      return (title || '').toLowerCase().replace(/&amp;/g, '&').split(/\s+[–—-]\s+/)[0]
        .replace(/\b(xxxl|xxl|xl|minis|mini|limited edition)\b/g, '')
        .replace(/[^a-z0-9äöüß]/g, '');
    };
    var fromElement = function (el) {
      var title = el.getAttribute('data-title');
      return { title: title, url: el.getAttribute('data-url'), image: el.getAttribute('data-image'), family: familyOf(title) };
    };
    var items = $$('[data-hero-item]', stage).map(fromElement);
    var knownUrls = new Set(items.map(function (item) { return item.url; }));
    var recentFamilies = slots.map(function (slot) { return familyOf($('[data-hero-name]', slot).textContent); });
    var previousFamilies = [];
    var busy = false, paused = false, loading = null, visible = false;
    new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { rootMargin: '100px' }).observe(stage);
    var loadMore = function () {
      if (page >= pages) return Promise.resolve();
      if (loading) return loading;
      loading = fetch('/?section_id=' + encodeURIComponent(section) + '&page=' + (page + 1))
        .then(function (response) { if (!response.ok) throw new Error('Figuren konnten nicht geladen werden'); return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = $$('[data-hero-item]', doc);
          next.forEach(function (el) {
            var item = fromElement(el);
            if (!knownUrls.has(item.url)) { items.push(item); knownUrls.add(item.url); }
          });
          page += 1;
        })
        .catch(function () { pages = page; })
        .finally(function () { loading = null; });
      return loading;
    };
    var loadCatalog = function () {
      if (page >= pages) return;
      loadMore().then(function () { if (page < pages) setTimeout(loadCatalog, 900); });
    };
    var pickGroup = function (extraAvoid) {
      var shuffled = items.slice();
      for (var i = shuffled.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = temp;
      }
      var group = [], used = new Set(), recent = new Set(recentFamilies.concat(extraAvoid || []));
      [true, false].forEach(function (avoidRecent) {
        shuffled.forEach(function (item) {
          if (group.length >= slots.length || used.has(item.family) || (avoidRecent && recent.has(item.family))) return;
          group.push(item); used.add(item.family);
        });
      });
      return group;
    };
    var advance = function (extraAvoid) {
      if (busy || !items.length) return;
      busy = true;
      var group = pickGroup(extraAvoid);
      if (group.length < slots.length) {
        busy = false;
        if (page < pages) loadMore().then(function () { advance(extraAvoid); });
        return;
      }
      Promise.all(group.map(function (item, index) {
        return new Promise(function (resolve) {
          var image = new Image();
          image.onload = function () { resolve(true); };
          image.onerror = function () { resolve(false); };
          image.src = responsiveImage(item.image, slots[index], 900).src;
        });
      })).then(function (loaded) {
        if (!loaded.every(Boolean)) return;
        slots.forEach(function (slot, i) {
          var image = $('img', slot);
          slot.href = group[i].url;
          var source = responsiveImage(group[i].image, slot, 900);
          image.sizes = slot.clientWidth + 'px';
          image.srcset = source.srcset;
          image.src = source.src;
          image.alt = group[i].title;
          $('[data-hero-name]', slot).textContent = group[i].title;
        });
        recentFamilies = recentFamilies.concat(group.map(function (item) { return item.family; })).slice(-12);
        stage.setAttribute('data-hero-ready', '');
      }).finally(function () { busy = false; });
    };
    advance(previousFamilies);

    stage.addEventListener('mouseenter', function () { paused = true; });
    stage.addEventListener('mouseleave', function () { paused = false; });
    stage.addEventListener('focusin', function () { paused = true; });
    stage.addEventListener('focusout', function (e) { if (!stage.contains(e.relatedTarget)) paused = false; });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () { if (visible && !paused && !document.hidden) { advance(); if (page < pages) loadMore(); } }, 10000);
    }
  });

  /* Jede Welt zeigt bei jedem Aufruf eine andere Figur aus ihrer Kollektion. */
  Array.prototype.slice.call(document.querySelectorAll('[data-world-card]')).forEach(function (card, index) {
    var image = $('[data-world-image]', card);
    var worldName = $('.jz-world__name', card).textContent;
    var familyOf = function (title) {
      return (title || '').toLowerCase().replace(/&amp;/g, '&').split(/\s+[–—-]\s+/)[0]
        .replace(/\b(xxxl|xxl|xl|minis|mini|limited edition)\b/g, '')
        .replace(/[^a-z0-9äöüß]/g, '');
    };
    var items = Array.prototype.slice.call(card.querySelectorAll('[data-world-item]')).map(function (el) {
      var title = el.getAttribute('data-title');
      return { title: title, image: el.getAttribute('data-image'), family: familyOf(title) };
    });
    if (!image || items.length < 2) return;
    var lastFamily = '';
    var busy = false, paused = false, visible = false;
    var change = function () {
      if (busy) return;
      var choices = items.filter(function (item) { return item.family && item.family !== lastFamily && item.image !== image.src; });
      if (!choices.length) return;
      for (var i = choices.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = choices[i]; choices[i] = choices[j]; choices[j] = temp;
      }
      busy = true;
      var tryImage = function (n) {
        if (n >= choices.length) { busy = false; return; }
        var next = choices[n], preload = new Image();
        preload.onload = function () {
          var source = responsiveImage(next.image, image.parentElement, 480);
          image.sizes = image.parentElement.clientWidth + 'px';
          image.srcset = source.srcset;
          image.src = source.src;
          image.alt = worldName + ': ' + next.title;
          lastFamily = next.family;
          card.setAttribute('data-world-ready', '');
          busy = false;
        };
        preload.onerror = function () { tryImage(n + 1); };
        preload.src = responsiveImage(next.image, image.parentElement, 480).src;
      };
      tryImage(0);
    };
    var firstView = true;
    new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; if (visible && firstView) { firstView = false; change(); } }, { rootMargin: '100px' }).observe(card);
    card.addEventListener('mouseenter', function () { paused = true; });
    card.addEventListener('mouseleave', function () { paused = false; });
    card.addEventListener('focusin', function () { paused = true; });
    card.addEventListener('focusout', function () { paused = false; });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(function () {
        setInterval(function () { if (visible && !paused && !document.hidden) change(); }, 18000);
      }, index * 2400);
    }
  });

  /* Mobile-Menü */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var d = $('[data-drawer]');
    if (!d) return;
    var header = $('.jz-header');
    if (header) d.style.setProperty('--drawer-top', header.getBoundingClientRect().bottom + 'px');
    var open = !d.classList.contains('is-open');
    d.classList.toggle('is-open', open);
    document.body.classList.toggle('jz-lock', open);
    t.textContent = open ? '✕' : '☰';
    t.setAttribute('aria-expanded', open);
  });

  /* Suche */
  var search = $('[data-search]');
  if (search) {
    var input = $('input', search), results = $('[data-search-results]', search), sugg = $('[data-search-suggestions]', search), timer;
    var openS = function () { search.classList.add('is-open'); document.body.classList.add('jz-lock'); setTimeout(function () { input.focus(); }, 30); };
    var closeS = function () { search.classList.remove('is-open'); document.body.classList.remove('jz-lock'); };
    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', openS); });
    $$('[data-search-close]', search).forEach(function (b) { b.addEventListener('click', closeS); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeS(); });
    $$('[data-search-term]', search).forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.getAttribute('data-search-term'); run(); });
    });
    var run = function () {
      var q = input.value.trim();
      sugg.hidden = !!q;
      if (!q) { results.innerHTML = ''; return; }
      fetch(R.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var ps = (data.resources && data.resources.results && data.resources.results.products) || [];
          var html = '<div class="jz-small">' + ps.length + ' Treffer für „' + q.replace(/</g, '&lt;') + '“</div>';
          if (!ps.length) {
            html += '<div class="jz-empty">Kein Jigglizz gefunden 🫧<div class="jz-small" style="margin-top:6px">Versuch es mit einer Welt, z. B. „Wasser“ oder „Dinos“.</div></div>';
          } else {
            ps.forEach(function (p) {
              html += '<a class="jz-result" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '&width=120" alt="">' : '') +
                '<span class="jz-result__name">' + p.title + '</span><span style="font-weight:600">' + p.price + ' €</span></a>';
            });
            html += '<a class="jz-btn" style="align-self:flex-start" href="' + R.searchPage + '?q=' + encodeURIComponent(q) + '&type=product">Alle Ergebnisse anzeigen →</a>';
          }
          results.innerHTML = html;
        });
    };
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 200); });
  }

  /* Warenkorb-Zähler */
  var refreshCount = function () {
    fetch(R.cart).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    });
  };

  /* Schnell in den Warenkorb (Produktkarten + Produktseite) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', f), label = btn ? btn.innerHTML : '';
    fetch(R.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        refreshCount();
        if (btn) {
          btn.classList.add('is-added');
          btn.innerHTML = btn.classList.contains('jz-round-btn') ? '✓' : '✓ Im Warenkorb';
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 1600);
        }
      })
      .catch(function () { f.submit(); });
  });

  /* Mengen-Stepper */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var inp = $('input', b.closest('.jz-qty'));
    var v = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
    inp.value = v;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Produktseite: Galerie + Varianten */
  $$('[data-product]').forEach(function (root) {
    var main = $('[data-gallery-main] img', root);
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main) { main.src = t.getAttribute('data-full'); main.removeAttribute('srcset'); }
      });
    });
    var json = $('[data-product-json]', root);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = $('[name="id"]', root), price = $('[data-price]', root), btn = $('[data-add]', root), qty = $('[name="quantity"]', root);
    var update = function () {
      var v;
      var card = $('[data-variant-card]:checked', root);
      if (card) {
        v = variants.find(function (x) { return String(x.id) === card.value; });
      } else {
        var optionFields = $$('[data-option]', root);
        var sel = optionFields.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        v = optionFields.length ? variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); }) : variants[0];
        optionFields.forEach(function (fs, i) { var l = $('legend span', fs); if (l) l.textContent = sel[i] || ''; });
      }
      if (!v) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; return; }
      idInput.value = v.id;
      var q = qty ? (parseInt(qty.value, 10) || 1) : 1;
      if (price) price.innerHTML = money(v.price) + (root.dataset.mystery !== 'true' && v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '') + '<small>inkl. MwSt., zzgl. Versand</small>';
      btn.disabled = !v.available;
      btn.textContent = v.available ? (btn.getAttribute('data-label') + ' ' + money(v.price * q)) : 'Ausverkauft';
      if (v.featured_image && main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option],[data-variant-card],.jz-qty')) update(); });
    update();
  });

  /* Produktempfehlungen */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = $('[data-recommendations]', d);
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    });
  });

  /* Weitere Katalogartikel unter den bereits sichtbaren Karten ergänzen. */
  var pagination = document.querySelector('[data-collection-pagination]');
  if (pagination) {
    var productGrid = document.querySelector('[data-collection-grid]');
    var loadingMore = false;
    pagination.addEventListener('click', function (event) {
      var link = event.target.closest('[data-collection-load-more]');
      if (!link || !productGrid) return;
      event.preventDefault();
      if (loadingMore) return;
      loadingMore = true;
      var nextUrl = link.href;
      link.textContent = 'Wird geladen …';
      link.setAttribute('aria-disabled', 'true');
      productGrid.setAttribute('aria-busy', 'true');
      fetch(nextUrl, { headers: { Accept: 'text/html' } })
        .then(function (response) { if (!response.ok) throw new Error('Katalogseite nicht erreichbar'); return response.text(); })
        .then(function (html) {
          var nextPage = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = nextPage.querySelector('[data-collection-grid]');
          if (!nextGrid) throw new Error('Keine Produktliste gefunden');
          var cards = Array.prototype.slice.call(nextGrid.querySelectorAll('.jz-card'));
          if (!cards.length) throw new Error('Keine weiteren Artikel gefunden');
          var known = new Set(Array.prototype.slice.call(productGrid.querySelectorAll('.jz-card__media[href]')).map(function (a) { return a.getAttribute('href'); }));
          var fragment = document.createDocumentFragment();
          cards.forEach(function (card) {
            var media = card.querySelector('.jz-card__media[href]');
            var url = media && media.getAttribute('href');
            if (url && !known.has(url)) { fragment.appendChild(card); known.add(url); }
          });
          productGrid.appendChild(fragment);
          var shown = productGrid.querySelectorAll('.jz-card').length;
          var total = parseInt(pagination.getAttribute('data-total'), 10) || shown;
          var count = pagination.querySelector('[data-collection-count]');
          var progress = pagination.querySelector('[data-collection-progress]');
          if (count) count.textContent = shown + ' von ' + total + ' Artikeln angezeigt';
          if (progress) progress.style.width = Math.min(100, shown * 100 / total) + '%';
          var nextLink = nextPage.querySelector('[data-collection-load-more]');
          if (nextLink) { link.href = nextLink.href; link.textContent = 'Mehr Jigglizz laden'; }
          else link.remove();
        })
        .catch(function () { link.textContent = 'Laden fehlgeschlagen – erneut versuchen'; })
        .finally(function () {
          loadingMore = false;
          link.removeAttribute('aria-disabled');
          productGrid.removeAttribute('aria-busy');
        });
    });
  }

  /* Sortierung */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page');
    location.href = url.toString();
  });
})();

/* Eigene Pastell-Symbole für Geschenk, Versand und Shop-Vorteile. */
(function () {
  var art = {
    '🎁': '<rect x="4" y="11" width="24" height="17" rx="4" fill="#B69CFF"/><rect x="2" y="8" width="28" height="7" rx="3" fill="#FFB38A"/><path d="M16 8v20M16 8C8 9 6 3 10 2c4-1 6 6 6 6Zm0 0s2-7 6-6c4 1 2 7-6 6Z" fill="#FFE477"/>',
    '📦': '<path d="m4 9 12-6 12 6v16l-12 6-12-6Z" fill="#FFB38A"/><path d="m4 9 12 6 12-6M16 15v16M10 6l12 6v7" fill="none"/><path d="m22 12-6 3v5l6-3Z" fill="#FFE477"/>',
    '🔒': '<rect x="5" y="13" width="22" height="17" rx="6" fill="#7BE0C3"/><path d="M10 13V9a6 6 0 0 1 12 0v4" fill="none"/><circle cx="16" cy="21" r="2" fill="#251C3D"/><path d="M16 23v3"/>',
    '✨': '<path d="M17 3c1 7 3 10 10 11-7 1-9 4-10 11-1-7-3-10-10-11 7-1 9-4 10-11Z" fill="#FFE477"/><path d="M6 21c.5 3 1.5 4 4 5-2.5 1-3.5 2-4 5-.5-3-1.5-4-4-5 2.5-1 3.5-2 4-5Z" fill="#7BE0C3"/>',
    '🤲': '<path d="M3 21h5l5 5h8l8-9c-1-3-3-3-5-1l-4 4M3 14h5l6 6h6c2 0 2 4 0 4h-7" fill="#FFB38A"/><path d="M16 14 10 8c-4-5 3-9 6-4 3-5 10-1 6 4Z" fill="#FF8FBC"/>',
    '🎀': '<path d="M14 12C5 2 1 4 3 14c1 5 6 4 11 1M18 12C27 2 31 4 29 14c-1 5-6 4-11 1" fill="#FF8FBC"/><path d="m14 16-4 13 6-3 6 3-4-13" fill="#FFB38A"/><rect x="12" y="10" width="8" height="9" rx="3" fill="#FFE477"/>',
    '🔁': '<path d="M6 13a10 10 0 0 1 17-6l4 4M26 19a10 10 0 0 1-17 6l-4-4" fill="none" stroke="#251C3D" stroke-width="3"/><path d="M27 4v7h-7M5 28v-7h7" fill="none" stroke="#251C3D" stroke-width="3"/><circle cx="16" cy="16" r="4" fill="#B69CFF"/>',
    '🎲': '<rect x="4" y="4" width="24" height="24" rx="7" fill="#B69CFF"/><g fill="#FFE477"><circle cx="10" cy="10" r="2"/><circle cx="22" cy="10" r="2"/><circle cx="16" cy="16" r="2"/><circle cx="10" cy="22" r="2"/><circle cx="22" cy="22" r="2"/></g>'
  };
  var pastelSerial = 0;
  function render() {
    var roots = document.querySelectorAll('.jz-btn,.jz-pill,.jz-trust>span,.jz-mini-card>span:first-child,.jz-value>span:first-child,.jz-footer__pay .jz-small,.jz-world-choice__icon');
    roots.forEach(function(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), nodes = [], node;
      while ((node = walker.nextNode())) { if (!node.parentElement.closest('svg')) nodes.push(node); }
      nodes.forEach(function(text) {
        var pattern = /(🎁|📦|🔒|✨|🤲|🎀|🔁|🎲)/g;
        if (!pattern.test(text.nodeValue)) return;
        var fragment = document.createDocumentFragment();
        text.nodeValue.split(pattern).forEach(function(part) {
          if (!art[part]) { fragment.appendChild(document.createTextNode(part)); return; }
          var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
          svg.setAttribute('viewBox','0 0 32 32'); svg.setAttribute('width','26'); svg.setAttribute('height','26');
          svg.setAttribute('class','jz-pastel-icon'); svg.setAttribute('aria-hidden','true'); svg.setAttribute('focusable','false');
          svg.setAttribute('stroke','#50345F'); svg.setAttribute('stroke-width','1.4'); svg.setAttribute('stroke-linecap','round'); svg.setAttribute('stroke-linejoin','round');
          var inCircle = root.matches('.jz-world-choice__icon') || root.closest('.jz-mini-card,.jz-value');
          var size = inCircle ? 34 : (root.closest('.jz-pill') ? 26 : 32);
          svg.setAttribute('style','display:inline-block;vertical-align:middle;flex-shrink:0;width:'+size+'px;height:'+size+'px;filter:drop-shadow(0 2px 1px rgba(10,5,25,.25))');
          var prefix = 'jz-pastel-'+(++pastelSerial)+'-', defs = '', shape = art[part];
          ['#B69CFF','#FFB38A','#FFE477','#7BE0C3','#FF8FBC'].forEach(function(color,index) {
            var id = prefix+index;
            defs += '<linearGradient id="'+id+'" x1="0" y1="0" x2=".7" y2="1"><stop offset="0" stop-color="'+color+'"/><stop offset=".45" stop-color="'+color+'"/><stop offset="1" stop-color="'+color+'" stop-opacity=".72"/></linearGradient>';
            shape = shape.split('fill="'+color+'"').join('fill="url(#'+id+')"');
          });
          svg.innerHTML = '<defs>'+defs+'</defs>'+shape;
          fragment.appendChild(svg);
        });
        text.replaceWith(fragment);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',render); else render();
  document.addEventListener('shopify:section:load',render);
})();


/* Suche auf passende Produktnamen und Schlagwoerter begrenzen. */
(function(){
  function strict(term){
    if (/\b(?:title|tag|body|vendor|product_type):/i.test(term)) return term;
    var words=(term.match(/[\p{L}\p{N}]+(?:[-\u2019'][\p{L}\p{N}]+)*/gu)||[]).filter(function(w){return !/^(und|der|die|das|ein|eine|mit|von|für|and|the|or)$/i.test(w);});
    return words.map(function(w){return '(title:"'+w+'" OR tag:"'+w+'" OR product_type:"'+w+'")';}).join(' AND ') || term;
  }
  var params=new URLSearchParams(location.search), term=params.get('jz_q');
  if(location.pathname==='/search' && params.get('q') && !term){
    var raw=params.get('q'), query=strict(raw);
    if(query!==raw){params.set('jz_q',raw);params.set('q',query);location.replace(location.pathname+'?'+params.toString());return;}
  }
  document.querySelectorAll('form[role="search"]').forEach(function(form){
    var input=form.querySelector('input[name="q"]');if(!input)return;
    if(term && location.pathname==='/search')input.value=term;
    form.addEventListener('submit',function(){var raw=input.value.trim();if(!raw)return;input.name='jz_q';var hidden=document.createElement('input');hidden.type='hidden';hidden.name='q';hidden.value=strict(raw);form.appendChild(hidden);});
  });
  if(term && location.pathname==='/search'){document.querySelectorAll('main .jz-small').forEach(function(el){if(/^\d+ Treffer/.test(el.textContent))el.textContent=el.textContent.match(/^\d+/)[0]+' Treffer für „'+term+'“';});}
})();
